<template>
  <m-form :formModel="formModel" ref="form" />
</template>

<script>
import MForm from './m-form'
import { getCustomerInfo } from 'views/customer-mangement/detail/info/basic-profile/api'
import { getSelectList } from '@/api'

export default {
  data() {
    return {
      formModel: [
        {
          type: 'select',
          label: 'Match Universe',
          defaultValue: 1,
          key: 'matchUniverse',
          selectList: [
            {
              id: 1,
              name: 'All Businesses',
            },
            {
              id: 2,
              name: 'In Date Financials Only',
            },
            {
              id: 3,
              name: 'Major Buinesses Only',
            },
          ],
          rule: [
            { required: true, message: 'Can not be empty!', trigger: 'change' },
          ],
        },
        {
          type: 'input',
          label: 'Company Name',
          key: 'companyName',
          rule: [
            { required: true, message: 'Can not be empty!', trigger: 'blur' },
          ],
        },
        {
          type: 'input',
          label: 'Address',
          key: 'address',
        },
        {
          type: 'input',
          label: 'City',
          key: 'city',
        },
        {
          type: 'input',
          label: 'State or Province',
          key: 'state',
        },
        {
          type: 'input',
          label: 'Postal Code',
          key: 'postalCode',
        },
        {
          type: 'select',
          label: 'Country',
          key: 'country',
          selectList: [],
          rule: [
            { required: true, message: 'Can not be empty!', trigger: 'blur' },
          ],
        },
      ],
    }
  },
  created() {
    this._getCountryList()
    this._getCustomerInfo()
  },
  methods: {
    async validate() {
      const valid = await this.$refs.form.validateForm()
      if (valid) {
        const result = await this.$refs.form.getFormData()
        result.country = this.countryList.filter(
          item => item.id === result.country,
        )[0].mark
        return result
      }
    },
    async _getCountryList() {
      try {
        const result = await getSelectList('Country')
        this.formModel[6].selectList = result
        this.countryList = result
      } catch (err) {
        console.error(err)
      }
    },
    async _getCustomerInfo() {
      try {
        const { base } = await getCustomerInfo(this.$route.params.customerId)
        this.formModel.forEach((item, index) => {
          if (item.key === 'companyName') {
            this.formModel.splice(index, 1, {
              ...item,
              defaultValue: base.name,
            })
          }
          if (item.key === 'address') {
            this.formModel.splice(index, 1, {
              ...item,
              defaultValue: base.address,
            })
          }
          if (item.key === 'country') {
            this.formModel.splice(index, 1, {
              ...item,
              defaultValue: base.country,
            })
          }
        })
      } catch (e) {
        console.log(e)
      }
    },
  },
  components: {
    MForm,
  },
}
</script>
